'use strict';

var CreateNicBond = require('actionGroups/createNicBond/CreateNicBond');

module.exports = {
  Model: CreateNicBond,
};
